import IArticleCampaigns from "../../types/IArticleCampaigns";
import IArticleCampaignsV2 from "../../types/IArticleCampaignsV2";
import ICampaignID from "../../types/ICampaignID";
import ICampaignInfoContainer from "../../types/ICampaignInfoContainer";
import ICategoryCampaigns from "../../types/ICategoryCampaigns";
import ICategoryCampaignsV2 from "../../types/ICategoryCampaignsV2";

// Class to work with localStorage as a campaing UUID container
export default class CampaignInfoStorageContainer implements ICampaignInfoContainer {
  readonly containerName = "localStorage";
  readonly parameterName = "campaign.bundle.campaignUUID";

  // Key template for localStorage to save items. Params will replace on store event.
  private readonly articlesKeyTemplate = "new.campaign.bundle.${campaignId}.${category}.articles";
  private readonly categoriesKeyTemplate = "new.campaign.bundle.${campaignId}.categories";

  load() {
    const result: ICampaignID = {
      UUID: JSON.parse(localStorage.getItem(this.parameterName)),
      container: this.containerName
    };
    return result.UUID ? result : null;
  }

  store(campaignId: ICampaignID) {
    if (!!campaignId && ["param", "cookie"].indexOf(campaignId.container) > -1) {
      try {
        localStorage.setItem(this.parameterName, JSON.stringify(campaignId.UUID));

        return true;
      } catch (error) {}
    }

    return false;
  }

  public storeCategories(campaignId: string, campaignInfo: ICategoryCampaigns | ICategoryCampaignsV2): boolean {
    try {
      localStorage.setItem(this.createStorageKey("categories", campaignId), JSON.stringify(campaignInfo));
    } catch (error) {
      return false;
    }

    return true;
  }

  public storeArticles(
    campaignId: string,
    category: string,
    campaignInfo: IArticleCampaigns | IArticleCampaignsV2
  ): boolean {
    try {
      localStorage.setItem(this.createStorageKey("articles", campaignId, category), JSON.stringify(campaignInfo));
    } catch (error) {
      return false;
    }

    return true;
  }

  public getCategories(campaignId: string): ICategoryCampaigns | ICategoryCampaignsV2 {
    return JSON.parse(localStorage.getItem(this.createStorageKey("categories", campaignId))) || {};
  }

  public getArticles(campaignId: string, category: string): IArticleCampaigns | IArticleCampaignsV2 {
    return JSON.parse(localStorage.getItem(this.createStorageKey("articles", campaignId, category))) || {};
  }

  // clear all campaign info from localStorage
  public empty(campaignId: string): boolean {
    try {
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i);
        if (key.indexOf(`new.campaign.bundle.${campaignId}`) === 0) {
          window.localStorage.removeItem(key);
        }
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  private createStorageKey(type: "articles" | "categories", campaignId: string, category?: string): string {
    const key = type === "articles" ? this.articlesKeyTemplate : this.categoriesKeyTemplate;
    return key.replace("${campaignId}", campaignId).replace("${type}", type).replace("${category}", category);
  }
}
